(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bogo-progress"] && !Shopify.designMode) return;
  try {
    class BogoProgress extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.count = null;
      // The cart event fires as the request starts; wait for its promise so we read the updated cart
      this.onCartUpdate = (event) => {
        const pending = event.promise || event.detail?.promise;
        if (pending && typeof pending.then === 'function') {
          pending.then(this.refresh, this.refresh);
        } else {
          setTimeout(this.refresh, 600);
        }
      };
      this.onPageShow = (event) => event.persisted && this.refresh();
      document.addEventListener('shopify:cart:lines-update', this.onCartUpdate);
      window.addEventListener('pageshow', this.onPageShow);
      this.startTimer();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:cart:lines-update', this.onCartUpdate);
      window.removeEventListener('pageshow', this.onPageShow);
      clearTimeout(this.timer);
    }

    // Counts down to the real end date set on the block (the same for every visitor)
    startTimer() {
      const end = Number(this.dataset.end) * 1000;
      const wrap = this.querySelector('[data-bogo-timer]');
      const out = this.querySelector('[data-bogo-time]');
      if (!end || !wrap || !out) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          wrap.hidden = true;
          return;
        }
        const d = Math.floor(left / 86400);
        const h = Math.floor((left % 86400) / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        out.textContent = `${d > 0 ? `${d}d ` : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
        this.timer = setTimeout(tick, 1000 - (Date.now() % 1000));
      };
      tick();
    }

    async refresh() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        this.render(await response.json());
      } catch (error) {
        // Leave the last state in place if the cart can't be read
      }
    }

    render(cart) {
      const types = (this.dataset.types || '').split(',').map((type) => type.trim()).filter(Boolean);
      const units = [];
      cart.items
        .filter((item) => types.includes(String(item.product_type || '').trim().toLowerCase()))
        .forEach((item) => {
          for (let i = 0; i < item.quantity; i += 1) units.push({ image: item.image || '', price: item.original_price || 0 });
        });

      const count = units.length;
      const size = Number(this.dataset.size) === 3 ? 3 : 2;
      const remainder = count % size;
      const free = Math.floor(count / size) * (size - 1);
      const fill = count === 0 ? 0 : remainder === 0 ? 100 : Math.floor((remainder * 100) / size);
      const complete = count > 0 && remainder === 0;
      const previous = this.count;
      this.count = count;

      const money = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cart.currency || this.dataset.currency || 'USD',
      }).format((cart.total_discount || 0) / 100);
      const saved = cart.total_discount > 0 ? `You saved ${money}.` : 'The discount comes off at checkout.';
      const one = this.dataset.one || 'watch';
      const many = this.dataset.many || 'watches';

      let strong;
      let rest;
      let next;
      if (size === 3) {
        if (count === 0) [strong, rest] = [`Your 2nd and 3rd ${many} are free.`, 'Add this one to get started.'];
        else if (count === 1) [strong, rest] = ['1 of 3 added.', "Add 2 more and they're free."];
        else if (count === 2) [strong, rest] = ['Almost there!', 'Add 1 more and 2 are free.'];
        else [strong, rest] = [`${free} of your ${count} ${many} are free.`, saved];
        if (count === 0) next = `Mix any 3 ${many}. The 2 lower-priced ones are free.`;
        else if (remainder === 0) next = 'Add <strong>3 more</strong> for another 2 free.';
        else next = `Mix and match any ${many}. The 2 lower-priced ones are free.`;
      } else {
        if (count === 0) [strong, rest] = [`Your 2nd ${one} is free.`, 'Add this one to get started.'];
        else if (count === 1) [strong, rest] = ['Halfway there!', "Add 1 more and it's free."];
        else
          [strong, rest] = [
            count === 2 ? `Your 2nd ${one} is free.` : `${free} of your ${count} ${many} ${free === 1 ? 'is' : 'are'} free.`,
            saved,
          ];
        if (count === 0) next = `Mix any 2 ${many}. The lower-priced one is free.`;
        else if (remainder === 0) next = `Add <strong>2 more</strong> for another free ${one}.`;
        else next = `Mix and match any ${many}. The lower-priced one is free.`;
      }

      const status = this.querySelector('[data-bogo-status]');
      const statusHtml = `<strong>${strong}</strong> <span>${rest}</span>`;
      if (status && status.innerHTML !== statusHtml) status.innerHTML = statusHtml;
      const nextEl = this.querySelector('[data-bogo-next]');
      if (nextEl) nextEl.innerHTML = next;
      const track = this.querySelector('[data-bogo-track]');
      if (track) track.setAttribute('aria-valuenow', String(fill));
      const fillEl = this.querySelector('[data-bogo-fill]');
      if (fillEl) fillEl.style.width = `${fill}%`;
      const shop = this.querySelector('[data-bogo-shop]');
      if (shop) shop.hidden = count === 0 || complete;

      // Slots: the set being built, or the last complete set
      const inSlots = complete ? size : remainder;
      // Highest price first: the lower-priced ones are the free ones
      const current = units
        .slice()
        .sort((a, b) => b.price - a.price)
        .slice(0, inSlots)
        .map((unit) => unit.image);
      this.querySelectorAll('.bogo-progress__slot').forEach((slot, index) => {
        const frame = slot.querySelector('.bogo-progress__slot-frame');
        const src = index < inSlots ? current[index] : '';
        const wasFilled = slot.classList.contains('is-filled');
        let img = frame.querySelector('img');
        const gift = frame.querySelector('.bogo-progress__gift');
        const preview = index === 0 && !src && this.dataset.productImage ? this.dataset.productImage : '';
        const show = src || preview;
        if (show) {
          if (!img) {
            img = document.createElement('img');
            img.alt = '';
            img.width = 80;
            img.height = 80;
            frame.prepend(img);
          }
          if (img.getAttribute('src') !== show) img.src = show;
          if (gift) gift.remove();
        } else if (img) {
          img.remove();
          if (!gift) frame.insertAdjacentHTML('afterbegin', OGIFT);
        }
        slot.classList.toggle('is-filled', Boolean(src));
        slot.classList.toggle('is-preview', !src && Boolean(preview));
        if (src && !wasFilled) {
          slot.classList.remove('is-pop');
          void slot.offsetWidth;
          slot.classList.add('is-pop');
        }
      });

      const wasComplete = this.classList.contains('is-complete');
      this.classList.toggle('is-complete', complete);
      if (complete && !wasComplete && previous !== null && count > previous) this.celebrate();
    }

    celebrate() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const burst = this.querySelector('[data-bogo-burst]');
      if (!burst) return;
      burst.innerHTML = '';
      const colors = ['#c9a45c', '#111', '#52b27f', '#e8c98a', '#b3261e'];
      for (let i = 0; i < 18; i += 1) {
        const dot = document.createElement('i');
        const angle = (i / 18) * Math.PI * 2;
        const distance = 60 + Math.random() * 50;
        dot.style.setProperty('--x', `${Math.cos(angle) * distance}px`);
        dot.style.setProperty('--y', `${Math.sin(angle) * distance - 20}px`);
        dot.style.background = colors[i % colors.length];
        burst.appendChild(dot);
      }
      burst.classList.remove('is-on');
      void burst.offsetWidth;
      burst.classList.add('is-on');
    }
  }

  const OGIFT =
    '<svg class="bogo-progress__gift" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="8.5" width="17" height="12" rx="1.5"/><path d="M2.5 8.5h19v-1a1 1 0 0 0-1-1h-17a1 1 0 0 0-1 1v1ZM12 6.5v14M12 6.5c-1.5-3.5-5.5-3.5-5.5-1 0 1 1.5 1 5.5 1Zm0 0c1.5-3.5 5.5-3.5 5.5-1 0 1-1.5 1-5.5 1Z"/></svg>';

  if (!customElements.get('bogo-progress')) customElements.define('bogo-progress', BogoProgress);
  } catch(e) { console.error(e); }
})();

})();
